import React, { useRef, useEffect, useState } from "react";
import "../Styles/Travelers_fav_hotel.css";
import api from "../Api";
import hotel_img from "../Images/hotelimg.jpg"
import { useNavigate } from "react-router-dom";
import grouptour from "../Images/grouptour1.jpg"
import packagetour from "../Images/packagetour1.jpg"
import customtour from "../Images/plantour1.jpg"
import weekendtour from "../Images/weekendtour1.jpg"
import transportimg from "../Images/transport_coverimg.png"
import activity from "../Images/activity.jpg"



const PropertyCarousel = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [hotelData, setHotelData] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        const fetchHotels = async () => {
            try {
                const res = await api.get("/hotels");
                if (res.data.status === true) {
                    console.log("Fetched hotels:", res.data.data);
                    setHotelData(res.data.data || []);
                    //   setFilteredItems(res.data.data || []);
                }
            } catch (err) {
                console.error("Error fetching hotels:", err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchHotels();
    }, []);
    const scrollRef = useRef(null);

    // Calculate scroll amount per click
    const handleScroll = (direction) => {
        const container = scrollRef.current;

        const card = container.querySelector(".property-card");
        const cardWidth = card ? card.offsetWidth + 20 : 300;

        const isLargeScreen = window.innerWidth >= 1024;
        const scrollAmount = isLargeScreen ? cardWidth * 4 : cardWidth * 1;

        if (direction === "right") {
            container.scrollTo({
                left: container.scrollLeft + scrollAmount,
                behavior: "smooth",
            });
        } else {
            container.scrollTo({
                left: container.scrollLeft - scrollAmount,
                behavior: "smooth",
            });
        }
    };


    const data = [
        {
            img: "https://i.pinimg.com/736x/0e/20/d8/0e20d8a70aa4eaa63fb579cd629ca784.jpg" ||hotel_img,
            title: "Hotel",
            link: "/hotels"
        },
        {
            img: grouptour,
            title: "Group Tour",
            link: "/tour/grouptour"
        },
        {
            img: packagetour,
            title: "Package Tour",
            link: "/tour/packagetour"
        },
        {
            img: customtour,
            title: "Plan Tour",
            link: "/tour/plantour"
        },
        {
            img: weekendtour,
            title: "Weekend Tour",
            link: "/tour/weekendtour"
        },
        {
            img: transportimg,
            title: " Book Transport",
            link: "/transports"
        },
        {
            img: activity,
            title: "Your favourite Activity",
            link: "/activities"
        },
        

    ];

    return (
        <div className="carousel-wrapper">


            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    <h2>Browse by Category</h2>
                    <p>From castles and villas to boats and igloos, we've got it all</p>
                </div>
                {/* <div ><button className='favourite_showmore' >Show More</button></div> */}
            </div>

            <button className="arrow left" onClick={() => handleScroll("left")}>
                ‹
            </button>
            <button className="arrow right" onClick={() => handleScroll("right")}>
                ›
            </button>

            <div className="carousel-container" ref={scrollRef}>
                {data.map((item, index) => (
                    <div className="property-card" key={index} onClick={() => navigate(`${item.link}`)} style={{ background: 'none', textAlign: "center" }}>
                        <div className="image-wrapper">
                            <img src={item.img || hotel_img} alt={item.name} />
                            {/* <span className="heart">♡</span> */}
                        </div>
                        <div>
                            <h3 style={{fontSize:"1rem",fontWeight:"700"}}>{item.title}</h3>
                        </div>

                        {/* <div className="card-info">
                            <div style={{display:"flex",width:"100%",justifyContent:"space-between"}}>
                                <p className="tag">Hotel</p>
                                <p style={{color:"green",fontWeight:"700"}}>₹{item.rooms[0].price_per_night}/night</p>
                                </div>
                            
                            <h3>{item.name}</h3>
                            <p className="location">{item.location}</p>

                            <div className="rating-box">
                                <span className="rating-number">{item.average_rating || 0} </span>
                                <span className="review-text">{item.reviews.length} reviews</span>
                            </div>
                        </div> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PropertyCarousel;
